import { render, staticRenderFns } from "./SidebarCartItemConfigurable.vue?vue&type=template&id=6e12dcce&"
import script from "./SidebarCartItemConfigurable.vue?vue&type=script&lang=js&"
export * from "./SidebarCartItemConfigurable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e12dcce')) {
      api.createRecord('6e12dcce', component.options)
    } else {
      api.reload('6e12dcce', component.options)
    }
    module.hot.accept("./SidebarCartItemConfigurable.vue?vue&type=template&id=6e12dcce&", function () {
      api.rerender('6e12dcce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/SidebarCartItemConfigurable.vue"
export default component.exports